import React, { useState } from "react";
import { Lock, Sparkles, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { isPlusUser } from "../lib/gentleflowPlus";

export default function PlusFeatureGate({ user, children, featureName = "This feature" }) {
  const [showUpgrade, setShowUpgrade] = useState(false);
  const navigate = useNavigate();
  if (isPlusUser(user)) return children;

  return <>
    <div className="relative rounded-3xl overflow-hidden">
      <div className="pointer-events-none select-none blur-[5px] opacity-45" aria-hidden="true">{children}</div>
      <button type="button" onClick={() => setShowUpgrade(true)} className="absolute inset-0 flex flex-col items-center justify-center bg-[#FFFDFC]/55 backdrop-blur-[1px] text-center p-6" aria-label={`Upgrade to Plus to unlock ${featureName}`}>
        <span className="w-12 h-12 rounded-2xl bg-[#332733] text-white flex items-center justify-center shadow-lg"><Lock className="w-5 h-5" /></span>
        <span className="mt-3 font-semibold text-[#332733]">Gentleflow Plus</span>
        <span className="mt-1 text-sm text-[#6F606C]">Unlock {featureName}</span>
      </button>
    </div>
    {showUpgrade && <div className="fixed inset-0 z-[180] flex items-center justify-center bg-black/45 backdrop-blur-sm p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-2xl">
        <button onClick={() => setShowUpgrade(false)} className="float-right w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center" aria-label="Close"><X className="w-4 h-4" /></button>
        <div className="w-12 h-12 rounded-2xl bg-[#FFBE98]/35 flex items-center justify-center"><Sparkles className="w-6 h-6 text-[#4A2937]" /></div>
        <h2 className="mt-4 text-xl font-semibold text-[#332733]">Unlock {featureName}</h2>
        <p className="mt-2 text-sm leading-6 text-[#6F606C]">This is part of Gentleflow Plus. Upgrade to access advanced insights and personalized tools.</p>
        <button onClick={() => navigate("/plus")} className="mt-5 w-full rounded-2xl bg-[#332733] text-white px-4 py-3 font-semibold">View Gentleflow Plus</button>
      </div>
    </div>}
  </>;
}
